import React from 'react';

import {
  Button,
  Label,
  Select,
  SelectTrigger,
  SelectItem,
  SelectLabel,
  SelectGroup,
  SelectContent,
  SelectValue,
} from '@cargomatic/ui';
import { Trash } from 'lucide-react';
import { equipmentTypes, equipmentSizes } from 'constants/Equipment';
import FormGrid from './FormGrid';

export default function EquipmentSizeRateConditionField({
  condition,
  onChange,
  onRemove,
}) {
  const { criteria: value } = condition;

  function handleRemove() {
    onRemove(condition);
  }

  function handleChange(criteria) {
    onChange({ ...condition, criteria });
  }
  return (
    <FormGrid>
      <Label className="w-48">Equip. Size</Label>
      <Select className="flex-1" value={value} onValueChange={handleChange}>
        <SelectTrigger className="">
          <SelectValue placeholder="Equip. Size" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel>Equip .Size</SelectLabel>
            {equipmentSizes.map((size) => (
              <SelectItem value={size} key={size}>
                {size}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      <div>
        <Button variant="icon" onClick={handleRemove}>
          <Trash className="w-3.5 h-3.5" />
        </Button>
      </div>
    </FormGrid>
  );
}
